export async function shareImage(certEl, { slug, id, name }) {
  const { default: html2canvas } = await import('html2canvas');
  if (document.fonts?.ready) await document.fonts.ready;
  const canvas = await html2canvas(certEl, { scale: 3, backgroundColor: '#fafafa', useCORS: true });
  const blob = await new Promise((r) => canvas.toBlob(r, 'image/png'));
  const file = new File([blob], `gay-certification-${slug || id}.png`, { type: 'image/png' });

  if (navigator.share && navigator.canShare?.({ files: [file] })) {
    try {
      await navigator.share({
        files: [file],
        title: 'Gay Certification',
        text: `${name ?? 'I'} got officially certified.`,
      });
      return;
    } catch { /* user cancelled */ }
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `gay-certification-${slug || id}.png`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
